import Swiper from 'swiper'

const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        effect : 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        // Pagination (bullet)
        pagination: {
            el: '.slideshow__pagination',
            type: 'bullets',
            clickable: true
        }
    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
    }
}

/*** Kiosque ***/
const kiosqueSlideshow = document.querySelector('.kiosque .swiper-container--kiosque') !== null;
        
if (kiosqueSlideshow) {
    let kiosqueSlides = document.querySelectorAll('.kiosque .swiper-container--kiosque .swiper-slide').length;

    let kiosqueConfig = {
        effect: 'fade',
        loop: true,
        slidesPerView: 1,
        //allowTouchMove: false,
        //simulateTouch: false,
        //noSwiping: true,

        keyboard: {
            enabled: true,
        },

        // Pagination (bullet)
        pagination: {
            el: '.kiosque__pagination',
            type: 'bullets',
            clickable: true
        },

        breakpoints: {
            1200: {
                allowTouchMove: false,
                simulateTouch: false,
            },
            0: {
                allowTouchMove: true,
                simulateTouch: true,
            },
        },
    }

    let swiperKiosque = new Swiper('.kiosque .swiper-container--kiosque', kiosqueConfig);


    /*** Kiosque thumbs ***/
    const thumbsSlideshow = document.querySelector('.kiosque .swiper-container--thumbs') !== null;

    let thumbsSlides = document.querySelectorAll('.kiosque .swiper-container--thumbs .swiper-slide').length;

    let thumbsConfig = {
        effect: 'slide',
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        slideToClickedSlide: true,
        

        // Lien entre le swiper des miniatures et le swiper principale pour la navigation par miniature
        thumbs: {
            swiper: swiperKiosque,
        },

        keyboard: {
            enabled: true,
        },

        breakpoints: {
            1201: {
                spaceBetween: 30,
            },
            0: {
                spaceBetween: 20,
            }

        },
    }

    let swiperThumbs = new Swiper('.kiosque .swiper-container--thumbs', thumbsConfig);
}

/*** Liens utiles ***/
const liensUtiles = document.querySelector('.usefull .swiper-container') !== null;
        
if (liensUtiles) {
    let liensUtilesSlides = document.querySelectorAll('.usefull .swiper-container .swiper-slide').length;

    let liensUtilesConfig = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        watchOverflow: true,
        rewind: true,
        centerInsufficientSlides: true,

        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },

        // Pagination (bullet)
        pagination: {
            el: '.usefull__pagination',
            type: 'bullets',
            clickable: true
        },

        breakpoints: {
            1201: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            
            961: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            
            641: {
                slidesPerView: 2,
                spaceBetween: 20,
            },

            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            }
        }
    }

    let swiperLiensUtiles = new Swiper('.usefull .swiper-container', liensUtilesConfig);
}
